export default __webpack_public_path__ + "static/media/logo-immunespace-whiteblue-desk.d53fe2e0.svg";